<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
        <!-- <b-form-group
            id="input-group-1"
            label="Email address:"
            label-for="input-1"
            description="We'll never share your email with anyone else."
          >
            <b-form-input
              id="input-1"
              v-model="form.email"
              type="email"
              placeholder="Enter email"
              required
            ></b-form-input>
          </b-form-group> -->
        <div class="flex w-full justify-between">
          <div class="w-48">
            <b-form-group
              id="input-group-2"
              label="First Name:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.firstname"
                placeholder="Enter name"
                required
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="w-48">
            <b-form-group
              id="input-group-2"
              label="Last Name:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.lastname"
                placeholder="Enter name"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="w-full flex justify-between">
          <div class="w-48">
            <b-form-group
              id="input-group-3"
              label="Gender:"
              label-for="input-3"
            >
              <b-form-select
                id="input-3"
                v-model="form.Gender"
                :options="Gender"
                required
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="w-48">
            <b-form-group
              id="input-group-2"
              label="Date of Birth:"
              label-for="input-2"
            >
              <base-input
                type="date"
                id="input-2"
                v-model="form.DOB"
                placeholder="Enter DOB"
                required
                :max="maxDate"
              ></base-input>
            </b-form-group>
          </div>
        </div>
        <div class="flex w-full justify-between">
          <div class="w-48">
            <b-form-group
              id="input-group-2"
              label="Experience:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.experience"
                placeholder="Enter Experience"
                required
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="w-48">
            <b-form-group
              id="input-group-2"
              label="Location:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.location"
                placeholder="Enter Location"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="flex w-full justify-between">
          <div class="w-48">
            <b-form-group
              id="input-group-2"
              label="Social Media:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.socialMedia"
                placeholder="Enter Social Media"
                required
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="w-48">
            <b-form-group
              id="input-group-2"
              label="Expertise:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.expertise"
                placeholder="Enter Expertise"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <b-button
          type="submit"
          variant="primary"
          class="flex m-auto text-center my-2"
          >Save</b-button
        >
      </b-form>
    </b-card>
  </div>
</template>

<style>
.w-48 {
  width: 48%;
}
</style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        email: "",
        firstname: "",
        lastname: "",
        Gender: null,
        checked: [],
        expertise: "",
        experience: "",
        socialMedia: "",
        location: "",
        DOB: "",
      },
      maxDate: null,
      Gender: [{ text: "Select One", value: null }, "Male", "Female", "others"],
      show: true,
    };
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();

      let payload = {
        volunteerId: this.get_volunteerbyuserId[0]._id,
        userId: this.get_volunteerbyuserId[0].userId._id,
        firstname: this.form.firstname,
        lastname: this.form.lastname,
        gender: this.form.Gender,
        expertise: this.form.expertise,
        experience: this.form.experience,
        socialMedia: this.form.socialMedia,
        location: this.form.location,
        DOB: this.form.DOB,
      };

      try {
        const data = await this.$store.dispatch(
          "respitecare/editvolunteer",
          payload
        );
        // console.log(data);
        if (data.code === 200) {
          await this.getVolunteer();
          // alert("volunteer updated!");
          await this.$swal({
            title: "",
            text: "Details updated!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
            confirmButtonText: "Okay",
            cancelButtonText: "",
          });
        }
        this.$router.go(-1);
        payload = {};
      } catch (error) {
        payload = {};
      }
    },
    async getVolunteer() {
      await this.$store.dispatch("respitecare/get_volunteerbyuserid", {
        volunteerId: this.get_volunteerbyuserId[0].userId._id,
      });
    },
    onReset(event) {
      event.preventDefault();
      this.form.name = "";
      this.form.Gender = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    init() {
      // console.log(this.get_volunteerbyuserId);
      this.form = {
        // email: this.get_volunteerbyuserId[0].email,
        firstname: this.get_volunteerbyuserId[0].userId.firstname,
        lastname: this.get_volunteerbyuserId[0].userId.lastname,
        Gender: this.get_volunteerbyuserId[0].gender,
        expertise: this.get_volunteerbyuserId[0].expertise,
        experience: this.get_volunteerbyuserId[0].experience,
        socialMedia: this.get_volunteerbyuserId[0].socialMedia,
        location: this.get_volunteerbyuserId[0].location,
        DOB: this.get_volunteerbyuserId[0].DOB,
      };
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_volunteerbyuserId: "get_volunteerbyuserId",
    }),
  },
  async mounted() {
    // await this.getVolunteer();
    this.init();
    const today = new Date().toISOString().split("T")[0];
    this.maxDate = today;
  },
};
</script>
